// @flow
import * as React from 'react';
import styled from 'styled-components';

const Text = styled.h1`
  font-weight: 400;
  letter-spacing: 0.1px;
  margin: 0.5rem 0;
`;

const Typography = (props: { kind: string, className?: string, children: React.Node }) => (
  <Text as={props.kind} className={props.className}>{props.children}</Text>
);

export const UnderlinedTypography = styled(Typography)`
  border-bottom: 1px solid lightgrey;
  padding-bottom: 1rem;
`;

export default Typography;
